import { LOAD_DISCOVER } from '../actions/discover';
const discover = (
  state = {
    geoLoc: { lat: '', lng: '' },
    deliveryAddress: '',
    instructions: ''
  },
  { type, payload }
) => {
  switch (type) {
    case LOAD_DISCOVER:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

export default discover;
